module.exports = __webpack_public_path__ + "static/media/svg-4.fbd1710a.svg";